import type { SVGProps } from 'react';

const DocHistory = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.25 15.75V16.25C17.25 17.9069 15.9069 19.25 14.25 19.25H7.75C6.09315 19.25 4.75 17.9069 4.75 16.25V7.75C4.75 6.09315 6.09315 4.75 7.75 4.75H10.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 12C18.7091 12 20.5 10.2091 20.5 8C20.5 5.79086 18.7091 4 16.5 4C14.2909 4 12.5 5.79086 12.5 8C12.5 10.2091 14.2909 12 16.5 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M16.5 5.79309V7.99999L17.6034 9.10344" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M7.75 15.25H14.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.75 12.25H9.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.75 9.25H9.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DocHistory;
